export default "__VITE_ASSET__aa63ab92__"